import { createAction, props } from '@ngrx/store';
import { SerializableUser } from './auth.models';

export const setCurrentUser = createAction(
  '[Auth] Set Current User',
  props<{ user: SerializableUser | null }>()
);

export const signInSuccess = createAction(
  '[Auth] Sign In Success',
  props<{ user: SerializableUser }>()
);

export const signOut = createAction('[Auth] Sign Out');
export const signOutSuccess = createAction('[Auth] Sign Out Success');
export const signOutFailure = createAction(
  '[Auth] Sign Out Failure',
  props<{ error: string }>()
);
